export default class CommonProfessionType {
  code: number
  description: string

  constructor(data: CommonProfessionType) {
    this.code = data.code
    this.description = data.description
  }
}
